import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../services/global-environment';
import { FormsModule } from '@angular/forms';  // 導入 FormsModule
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-compliance-import',
  templateUrl: './compliance-import.component.html',
  styleUrls: ['./compliance-import.component.scss'],
   standalone: true,  // 如果是 standalone component
  imports: [CommonModule, FormsModule]  // 加入所需模組
})
export class ComplianceImportComponent implements OnInit, OnChanges {
  @Input() companyId: string = "";
  @Input() show: boolean = false;
  @Input() items: any[] = []; // 父元件傳入的 unfitItems

  @Output() close = new EventEmitter<void>();
  @Output() itemsImported = new EventEmitter<any[]>();

  // 資料屬性
  availableTopics: string[] = [];
  availableTitles: string[] = [];
  selectedTopic: string = '';
  selectedTitle: string = '';
  selectedItemIds: Set<string> = new Set();

  filteredItems: any[] = [];

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    // 不在 ngOnInit 處理資料，避免初次 items 為空
  }

  ngOnChanges(changes: SimpleChanges) {
    // 只要 items 有變動就更新資料
    if (changes['items'] && changes['items'].currentValue && changes['items'].currentValue.length > 0) {
      this.updateAvailableTopicsAndTitles();
      this.filterItems();
    }
    // 每次 show 變為 true 時重設表單
    if (changes['show'] && changes['show'].currentValue === true) {
      this.resetForm();
      // 若 items 已有資料，立即更新
      if (this.items && this.items.length > 0) {
        this.updateAvailableTopicsAndTitles();
        this.filterItems();
      }
    }
  }

  // 重設表單
  resetForm() {
    this.selectedTopic = '';
    this.selectedTitle = '';
    this.selectedItemIds.clear();
  }

  // 背景點擊處理
  onModalBackdropClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeModal();
    }
  }

  // 關閉視窗
  closeModal() {
    this.resetForm();
    this.close.emit();
  }

  updateAvailableTopicsAndTitles(): void {
    const topics = new Set<string>();
    const titles = new Set<string>();
    for (const item of this.items) {
      if (item.topic) topics.add(item.topic);
      if (item.title) titles.add(item.title);
    }
    this.availableTopics = Array.from(topics);
    this.availableTitles = Array.from(titles);
  }

  // 當選擇主題時
  onTopicChange() {
    this.filterItems();
  }

  // 當選擇標題時
  onTitleChange(): void {
    this.filterItems();
  }

  filterItems(): void {
    this.filteredItems = this.items.filter(item => {
      const matchTopic = this.selectedTopic ? item.topic === this.selectedTopic : true;
      const matchTitle = this.selectedTitle ? item.title === this.selectedTitle : true;
      return matchTopic && matchTitle;
    });
  }

  // 處理項目選擇
  toggleItemSelection(id: string): void {
    if (this.selectedItemIds.has(id)) {
      this.selectedItemIds.delete(id);
    } else {
      this.selectedItemIds.add(id);
    }
  }

  // 匯入選擇的項目
  importSelectedItems() {
    if (this.selectedItemIds.size === 0) {
      alert('請至少選擇一個項目');
      return;
    }

    // 獲取選擇的項目
    const selectedItems = this.filteredItems.filter(item =>
      this.selectedItemIds.has(item.id)
    );

    // 發送匯入事件
    this.itemsImported.emit(selectedItems);
    this.closeModal();
  }

  // 全選/取消全選
  toggleSelectAll(event: any) {
    const isChecked = event.target.checked;

    if (isChecked) {
      // 全選
      this.selectedItemIds = new Set(this.filteredItems.map(item => item.id));
    } else {
      // 取消全選
      this.selectedItemIds.clear();
    }
  }

  // 檢查是否全部選中
  get allSelected(): boolean {
    return this.filteredItems.length > 0 &&
           this.selectedItemIds.size === this.filteredItems.length;
  }
}
